import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prepareForPrimeNgTranslation',
  standalone: false
})
export class PrepareForPrimeNgTranslation implements PipeTransform {
  transform(input: string): string {
    return input.replace(/\{\{([^{}]*)\}\}/g, '{$1}');
  }
}
